import './Caret-e686f04c.css';

var classes = {"Caret":"prc-components-Caret-PNu-B","CaretTriangle":"prc-components-CaretTriangle-Iu0GY","CaretBorder":"prc-components-CaretBorder-o3vP2"};

export { classes as default };
